import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MsalProvider } from '@azure/msal-react'
import './index.css'
import './styles/theme.css'
import './modules/dashboardScorecard/styles/dashboard-scorecard.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary'
import './utils/errorForwarding' // Initialize error forwarding
import { setupAxiosInterceptors, setupGlobalAxiosInterceptors } from './api/axiosInterceptor'
import { setupFetchInterceptor } from './utils/fetchInterceptor'
import { ensureMsalInitialized, getRedirectResponse, msalInstance } from './auth/msalConfig'

// Initialize network error tracking
setupAxiosInterceptors()
setupGlobalAxiosInterceptors()
setupFetchInterceptor()

const queryClient = new QueryClient()

// IMPORTANT: drain the redirect response BEFORE React (and React Router)
// mounts, otherwise BrowserRouter rewrites the URL and the auth code is lost.
ensureMsalInitialized()
  .then(() => getRedirectResponse())
  .catch((err) => console.error('MSAL bootstrap failed', err))
  .finally(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </QueryClientProvider>
        </MsalProvider>
      </StrictMode>,
    )
  })
